import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root = ({ colorsV2 }: ExactTheme) => css`
  border: none;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: relative;
  cursor: pointer;
  color: ${colorsV2.grey[800]};
  transition: 150ms;

  width: 20px;
  height: 20px;
  border-radius: 4px;

  &:disabled {
    cursor: default;
    color: ${colorsV2.grey[200]};
    &:hover {
      background: transparent;
    }
  }

  &:hover {
    background: ${colorsV2.grey[50]};
  }
  &:focus {
    outline: none;
  }
  &:focus-visible {
    background: ${colorsV2.grey[100]};
  }
`;
